import React from "react";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ReusableDialog = ({
  title,
  subtitle,
  children,
  isOpen,
  handleDialogClose,
}) => {
  return (
    <>
      <Dialog maxWidth="md" open={isOpen} onClose={handleDialogClose}>
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            paddingTop:"1.6rem"
          }}
        >
          <h1 style={{ fontSize: "1.5rem", fontWeight: "700" }}> {title}</h1>
          <CloseIcon onClick={handleDialogClose} sx={{ cursor: "pointer" }} />
        </DialogTitle>
        
        <DialogContent style={{ width: "800px",paddingBottom:"8px" }}>
          <DialogContentText>{subtitle}</DialogContentText>
          {children}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ReusableDialog
